// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmCompanyBlock_description__mOtVk"};